import { createContext, useContext } from 'react';

type DashboardProcsContextType = {
  refetchProcs: () => void;
};

export const DashboardProcsContext = createContext<DashboardProcsContextType>(
  {} as DashboardProcsContextType,
);

export const useDashboardProcsContext = () => {
  const context = useContext(DashboardProcsContext);

  if (context === undefined) {
    throw new Error(
      'useDashboardProcsContext must be used within DashboardProcsProvider',
    );
  }
  return context;
};
